export default "assets/assets.glb";